/* eslint-disable no-undef */
import React from "react";
import { useEffect, useState } from "react";
import axios from "axios";
import { formatDate, formatPrice } from "../utils/helpers";
import { countrySettings } from "../utils/country-settings";

const SingleBooking = () => {
  const [countryCode, setCountryCode] = useState("");
  const [parkServices, setParkServices] = useState(null);
  const [caravanPrice, setCaravanPrice] = useState(null);
  const [cottagePrice, setCottagePrice] = useState(null);

  let {
    bookingParkId,
    language,
    translations,
    urls,
    themeUrl,
    cottages,
    maintenance,
  } = pluginGlobals;

  if (
    !bookingParkId &&
    bookingPageSelectedPark &&
    bookingPageSelectedPark > 0
  ) {
    bookingParkId = bookingPageSelectedPark;
  }

  let cottageCat = false;
  if (
    cottages &&
    !cottages.categoryId &&
    typeof bookingPageCottageCategory !== "undefined" &&
    bookingPageCottageCategory > 0
  ) {
    cottageCat = bookingPageCottageCategory;
  }

  let maintenanceAvailable = true;
  if (typeof maintenance !== "undefined" && maintenance && maintenance.status) {
    maintenanceAvailable = maintenance.status === "available";
  }

  if (
    typeof bookingPageMaintenanceAvailable !== "undefined" &&
    bookingPageMaintenanceAvailable &&
    bookingPageMaintenanceAvailable !== ""
  ) {
    maintenanceAvailable = bookingPageMaintenanceAvailable === "available";
  }

  const today = new Date();
  const endDate = new Date().setDate(today.getDate() + 30);
  const bestparkApiParkUrl = `https://api.bestpark.com/parks/`;

  useEffect(() => {
    if (!bookingParkId || !language) return;

    axios
      .get(`${bestparkApiParkUrl}${bookingParkId}?data=booking`)
      .then((response) => {
        if (response.data) {
          setCountryCode(response.data.countryCode);
          setParkServices({
            serviceEntryPrice: response.data.serviceEntryPrice,
            availableServices: {
              caravan: response.data.caravan,
              cottages: response.data.categories,
              maintenance: response.data.maintenance,
            },
          });
        } else {
          setCountryCode("FI");
          setParkServices(null);
        }
      });

    axios
      .get(
        `${bestparkApiParkUrl}${bookingParkId}/prices?startDate=${formatDate(
          today
        )}&endDate=${formatDate(endDate)}`
      )
      .then((response) => {
        const dates = Object.values(response.data.result);
        const prices = dates.map((date) => {
          return date.price;
        });
        const min = Math.min.apply(null, prices);
        setCaravanPrice(min);
      });
  }, [bookingParkId, language]);

  useEffect(() => {
    if (((cottages && cottages.categoryId) || cottageCat) && bookingParkId) {
      const catID =
        typeof bookingPageCottageCategory !== "undefined"
          ? bookingPageCottageCategory
          : cottages.categoryId;
      axios
        .get(
          `${bestparkApiParkUrl}${bookingParkId}/prices?startDate=${formatDate(
            today
          )}&endDate=${formatDate(endDate)}&category=${catID}`
        )
        .then((response) => {
          const dates = Object.values(response.data.result);
          const prices = dates.map((date) => {
            return date.price;
          });
          const min = Math.min.apply(null, prices);
          setCottagePrice(min);
        });
    }
  }, [bookingParkId, cottages, cottageCat]);

  const services = parkServices ? parkServices.availableServices : {};
  const currencySymbol = countryCode
    ? countrySettings[countryCode].currencySymbol
    : "";

  const getTentText = (language) => {
    let tentText = "";
    switch (language) {
      case "fi":
        tentText = "Telttapaikka";
        break;
      case "sv":
        tentText = "Tältplats";
        break;
      case "de":
        tentText = "Zeltplatz";
        break;
      default:
        // Use english as default
        tentText = "Tent site";
        break;
    }
    return tentText;
  };

  const isTent =
    (typeof cottages !== "undefined" &&
      typeof cottages.tents !== "undefined" &&
      cottages.tents === true) ||
    (typeof bookingPageCottageType !== "undefined" &&
      bookingPageCottageType === "tent");
  const cottageIcon = isTent ? "tent3" : "cottage";
  const cottageText = isTent
    ? getTentText(language)
    : translations.bookCottageCtaText;

  return (
    <>
      <h2>{translations.bookTitleText}</h2>
      <a href={`${urls.booking}/${bookingParkId}`}>
        <span>
          <img src={`${themeUrl}/img/parks/caravan.svg`} alt="" />
        </span>
        <span
          style={{
            paddingTop: !services || !services.maintenance ? "11px" : "",
            display: !services || !services.maintenance ? "inline-block" : "",
          }}
        >
          {translations.bookCtaText}
        </span>
        {caravanPrice ? (
          <>
            <br />
            {translations.fromText} {formatPrice(caravanPrice, currencySymbol)}
          </>
        ) : null}
      </a>
      {maintenanceAvailable && (
        <a href={`${urls.maintenanceBooking}/${bookingParkId}`}>
          <span>
            <img
              src={`${themeUrl}/img/parks/maintenance.svg`}
              alt=""
              style={{ width: "22px" }}
            />
          </span>
          <span
            style={{
              paddingTop: !services || !services.maintenance ? "11px" : "",
              display: !services || !services.maintenance ? "inline-block" : "",
            }}
          >
            {translations.bookMaintenanceCtaText}
          </span>
          {parkServices && parkServices.serviceEntryPrice ? (
            <>
              <br />
              {translations.fromText}{" "}
              {formatPrice(parkServices.serviceEntryPrice, currencySymbol)}
            </>
          ) : null}
        </a>
      )}
      {cottagePrice && (
        <a
          href={`${urls.cottageBooking}/${bookingParkId}/${
            cottageCat ? cottageCat : cottages.categoryId
          }`}
        >
          <span>
            <img src={`${themeUrl}/img/parks/${cottageIcon}.svg`} alt="" />
          </span>
          <span>{cottageText}</span>
          <br />
          {translations.fromText} {formatPrice(cottagePrice, currencySymbol)}
        </a>
      )}
    </>
  );
};
export default SingleBooking;
